import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Toaster } from "sonner";
import { BrandProvider } from "./lib/brand";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <BrandProvider>
      <App />
    </BrandProvider>
    <Toaster richColors position="top-right" />
  </>
);

// Register the PWA service worker (installable on mobile home screen).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
